//供应商管理
import Layout from '../views/layout/layout'

export default {
    path: '/supplyInfo',
    name: 'supplyInfo',
    component: Layout,
    children: [
        {
            path: '/supplyInfo/index',
            name: 'supplyInfoIndex',
            component: () => import('../views/investment/supply/index'),
            meta: {title: '供应商管理', keepAlive: true}
        },
        {
            path: '/spinOffRate/index',
            name: 'spinOffRateIndex',
            component: () => import('../views/investment/spinOffRate/index'),
            meta: {title: '集团利润系数维护', keepAlive: true}
        },
        {
            path: '/agreementInfo/agreementCommon',
            name: 'agreementInfo',
            component: () => import('../views/investment/agreementCommon'),
            meta: {title: '补充协议'}
        },
        {
            path: '/supplyInfoRenew/index',
            name: 'supplyInfoRenewIndex',
            component: () => import('../views/investment/supplyRenew/index'),
            meta: {title: '供应商续签管理', keepAlive: true}
        },
        {
            path: '/shopInfo/index',
            name: 'shopInfoIndex',
            component: () => import('../views/investment/shop/index'),
            meta: {title: '店铺管理', keepAlive: true}
        },
        {
            path: '/shopInfoRenew/index',
            name: 'shopInfoRenewIndex',
            component: () => import('../views/investment/shopRenew/index'),
            meta: {title: '店铺续签管理', keepAlive: true}
        },
        {
            path: '/supplyInfo/add',
            name: 'supplyInfoAdd',
            component:()=>import('../views/investment/supply/add'),
            meta: {title: '供应商管理新增'}
        },
        {
            path: '/supplyInfo/detailSupply',
            name: 'detailSupply',
            component: () => import('../views/investment/supply/detailSupply'),
            meta: {title: '供应商管理详情'}
        },
        {
            path: '/shopInfo/add',
            name: 'shopInfoAdd',
            component: () => import('../views/investment/shop/add'),
            meta: {title: '店铺管理新增'}
        },
        {
            path: '/shopInfo/addChooseSupply',
            name: 'shopInfoAddChooseSupply',
            component: () => import('../views/investment/shop/addChooseSupply'),
            meta: {title: '选择供应商'}
        },
        {
            path: '/shopInfo/detailShop',
            name: 'detailShop',
            component: () => import('../views/investment/shop/detailShop'),
            meta: {title: '店铺管理详情'}
        },
        {
            path: '/supplyInfoRenew/add',
            name: 'supplyInfoRenewAdd',
            component: () => import('../views/investment/supplyRenew/add'),
            meta: {title: '供应商续签'}
        },
        {
            path: '/supplyInfoRenew/detailSupply',
            name: 'supplyInfoRenewDetail',
            component: () => import('../views/investment/supplyRenew/detailSupply'),
            meta: {title: '供应商续签详情'}
        },
        {
            path: '/shopInfoRenew/add',
            name: 'shopInfoRenewAdd',
            component: () => import('../views/investment/shopRenew/add'),
            meta: {title: '店铺续签'}
        },
        {
            path: '/shopInfoRenew/detailShop',
            name: 'shopInfoRenewDetail',
            component: () => import('../views/investment/shopRenew/detailShop'),
            meta: {title: '店铺续签详情'}
        },
        {
            path: '/supplyApply/index',
            name: 'supplyApplyIndex',
            component: () => import('../views/investment/supplyApply/index'),
            meta: {title: '供应商申请管理', keepAlive: true}
        },
        {
            path: '/supplyApply/select',
            name: 'supplyApplySelect',
            component: () => import('../views/investment/supplyApply/apply'),
            meta: {title: '选择申请池', keepAlive: true}
        },
        {
            path: '/supplySubject/index',
            name: 'supplySubjectIndex',
            component: () => import('../views/investment/supplySubject/index'),
            meta: {title: '签约主体管理', keepAlive: true}
        },
    ]
}
